class WorkflowError extends Error {
    constructor({stepName, message, workflowErrorData = null}) {
        super(message);
        this.name = "WorkflowError";
        this.stepName = stepName;
        this.errorData = workflowErrorData;
    }
}

export default WorkflowError;


//////////////////
// WEBPACK FOOTER
// ./src/models/errors/WorkflowError.js
// module id = 7pDS
// module chunks = 1